export function getCurrentState<T>(setState: React.Dispatch<React.SetStateAction<T>>) {
    return new Promise<T>((res) => {
        setState((state) => {
            res(state);
            return state;
        });
    });
}
